import React from 'react'
import Fragment from '../common/fragment'


function FragmentCR(props) {
  return (
    <Fragment pos="rrr" {...props}>
      <p>
Jerusalem en las praderas, sin Templo y sin cruces, por donde corre el Judas que
será sacrificado, entre la furia y el gozo. Un Judas Negro y un Cristo Negro. Cristo
de noche se cubrió de gloria, Judas de día, traición y culpa. Como un cuadro de
Malevich, negro sobre negro. Dimisión de la luz.
      </p>
    </Fragment>
  )
}


export default FragmentCR
